// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
// import Mock from './mock'
import AxiosConfig from './config/AxiosConfig'
import VueConfig from './config/VueConfig'
import Mixin from './config/Mixin'
//import 'element-ui/lib/theme-default/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import VueI18n from 'vue-i18n'
import zh_cn from './lang/zh_CN'
import en_us from './lang/en_US'


AxiosConfig.init()
// Mock.init()
Vue.use(VueConfig)
Vue.mixin(Mixin)

Vue.config.productionTip = false
Vue.use(ElementUI)
//配置语言
// let locales = {
//   zh: zh,
//   en: en
// }
// console.log(VueI18n)
// const i18n = new VueI18n({
//   locale: 'zh', // set locale
//   messages // set locale messages
// })
// Vue.use(VueI18n, {
//   locale: 'zh',
//   locales: locales
// })
Vue.use(VueI18n)
const messages = {
  zh_cn,
  en_us
}
let lang = localStorage.getItem("lang")
if (!lang) {
  lang = navigator.language.replace("-", "_").toLowerCase();
}
const i18n = new VueI18n({
  locale: lang, // set locale
  messages, // set locale messages
  fallbackLocale: "zh_cn"
})
/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
  i18n
})
export default vue


// WEBPACK FOOTER //
// ./src/main.js